module.exports = __webpack_public_path__ + "images/category_lp/watch/assessment_achievements/4@2x_b4f34b054b5dadda3fc30f47362e5004.png";